module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-photo-civil-ceremony-39836c640790a8ed5c4ab1feeff50673.jpg";